
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IUnreadMessagesPresence, TError } from './types/unread-messages-interface'

const unreadMessagesPresenceState = (state: RootState): IUnreadMessagesPresence => state.unreadMessagesPresence

export const unreadMessagesPresenceSelector = createSelector(
    [unreadMessagesPresenceState],
    (state): boolean => state.unreadMessagesPresence,
)
export const ErrorUnreadMessagesPresence = createSelector(
    [unreadMessagesPresenceState],
    (state): TError => state.errorUnreadMessagesPresence,
)
export const LoadingUnreadMessagesPresence = createSelector(
    [unreadMessagesPresenceState],
    (state): boolean => state.isLoadingUnreadMessagesPresence,
)